module.exports = __webpack_public_path__ + "static/media/LogicWedge6_2_continue_1.ffe0c792.png";